// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"95":"d93c077d","132":"28a1b41e","153":"f5038449","239":"e786d293","296":"e3cf0811","384":"16e50ef9","552":"31c4d181","697":"e3bcd1d8"}[chunkId] + ".chunk.js";
};